import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, immediate = false, className = "" }) {
  const variants = { hidden: { y: "110%" }, shown: { y: 0 } };
  if (immediate) {
    return (
      <span className={`block overflow-hidden ${className}`}>
        <motion.span
          className="block will-change-transform"
          initial="hidden"
          animate="shown"
          variants={variants}
          transition={{ duration: 0.9, delay, ease: EASE }}
        >
          {children}
        </motion.span>
      </span>
    );
  }
  return (
    <motion.span
      className={`block overflow-hidden ${className}`}
      initial="hidden"
      whileInView="shown"
      viewport={{ once: true, margin: "-10%" }}
    >
      <motion.span
        className="block will-change-transform"
        variants={variants}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
}

export function FadeIn({ children, delay = 0, y = 24, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ index, label }) {
  return (
    <FadeIn>
      <p className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500">
        <span className="text-brand">{index}</span>
        <span className="h-px w-10 bg-brand/60" />
        {label}
      </p>
    </FadeIn>
  );
}

export function ParallaxImage({ src, alt, className = "" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <div ref={ref} className={`clip-frame overflow-hidden ${className}`}>
      <motion.img src={src} alt={alt} style={{ y }} className="h-[115%] w-full scale-110 object-cover" />
    </div>
  );
}
